
import jwt_decode from "jwt-decode";

export function checkLogin() {
  const token = sessionStorage.getItem("token");
  if (token) {
    const decoded = jwt_decode(sessionStorage.getItem("token"));
    const exp = decoded.exp;
    //const orig_iat = deco

    // if its expiring in a short period of time
    if (exp - Date.now() / 1000 < 1800) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
}